import { connect } from "react-redux";
import get from "lodash/get";

import {
  sendMail as onSendMail,
  handleChangeStoreSendMail as onHandleChangeStore,
  getRestoreData as onGetRestoreData,
  restorePassword as onRestorePassword,
} from "./../../actions/restoreActions";

const mapStateToProps = (state) => ({
  restore: {
    dataState: state.restore.dataState,
    sendEmailDataState: state.restore.sendEmailDataState,
    getRestoreDataState: state.restore.getRestoreDataState,
    email: get(state, ["restore", "email"], null),
    restoreItems: get(state, ["restore", "restoreItems"], {}),
    errors: get(state, ["restore", "errors", "data"], null),
  },
});

const mapDispatchToProps = { onSendMail, onHandleChangeStore, onGetRestoreData, onRestorePassword };

const withRestore = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withRestore };
